export default __webpack_public_path__ + "img/eOmwKYwn.1955baf2.svg";